module.exports = __webpack_public_path__ + "img/TIMELINE.6515edc1.svg";